export default "__VITE_ASSET__DYp2Ll4t__"